import createCache from "@emotion/cache";
import { CacheProvider } from "@emotion/react";
import { ThemeProvider as MUIThemeProvider } from "@mui/material/styles";
import { CssBaseline } from "@mui/material";
import { theme } from "./theme.config";

interface ThemeProviderProps {
    children: React.ReactNode;
}

/**
 * Theme provider component that provides Material-UI theme with system preference support
 *
 * Features:
 * - System preference detection (light/dark)
 * - Manual theme switching
 * - Prevents dark mode flickering
 * - CSS variables for better performance
 */
function ThemeProvider(props: ThemeProviderProps) {
    const { children } = props;

    const emotionCache = createCache({ key: "css" });

    return (
        <CacheProvider value={emotionCache}>
            <MUIThemeProvider theme={theme}>
                <CssBaseline />
                {children}
            </MUIThemeProvider>
        </CacheProvider>
    );
}

export default ThemeProvider;
